export default "__VITE_ASSET__CvDRLQxh__"